export default __webpack_public_path__ + "static/media/icon-support-3.172d5549.svg";